import React from 'react';

export default function SvgLoungeIcon(props) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="currentColor" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.43934 1.93934C2.72064 1.65804 3.10218 1.5 3.5 1.5H8.5C8.89782 1.5 9.27936 1.65804 9.56066 1.93934C9.84196 2.22064 10 2.60217 10 3V4.5C10 4.77614 9.77614 5 9.5 5C9.22386 5 9 4.77614 9 4.5V3C9 2.86739 8.94732 2.74021 8.85355 2.64645C8.75979 2.55268 8.63261 2.5 8.5 2.5H3.5C3.36739 2.5 3.24021 2.55268 3.14645 2.64645C3.05268 2.74021 3 2.86739 3 3V4.5C3 4.77614 2.77614 5 2.5 5C2.22386 5 2 4.77614 2 4.5V3C2 2.60218 2.15804 2.22064 2.43934 1.93934Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.43934 4.43934C1.72064 4.15804 2.10217 4 2.5 4C2.89783 4 3.27936 4.15804 3.56066 4.43934C3.84196 4.72064 4 5.10218 4 5.5V6H8V5.5C8 5.10217 8.15804 4.72064 8.43934 4.43934C8.72064 4.15804 9.10217 4 9.5 4C9.89783 4 10.2794 4.15804 10.5607 4.43934C10.842 4.72064 11 5.10217 11 5.5V8C11 8.39782 10.842 8.77936 10.5607 9.06066C10.2794 9.34196 9.89783 9.5 9.5 9.5H2.5C2.10217 9.5 1.72064 9.34196 1.43934 9.06066C1.15804 8.77936 1 8.39782 1 8V5.5C1 5.10218 1.15804 4.72064 1.43934 4.43934ZM2.5 5C2.36739 5 2.24021 5.05268 2.14645 5.14645C2.05268 5.24021 2 5.36739 2 5.5V8C2 8.13261 2.05268 8.25978 2.14645 8.35355C2.24021 8.44732 2.36739 8.5 2.5 8.5H9.5C9.63261 8.5 9.75978 8.44732 9.85355 8.35355C9.94732 8.25978 10 8.13261 10 8V5.5C10 5.36739 9.94732 5.24022 9.85355 5.14645C9.75978 5.05268 9.63261 5 9.5 5C9.36739 5 9.24022 5.05268 9.14645 5.14645C9.05268 5.24022 9 5.36739 9 5.5V6.25C9 6.44891 8.92098 6.63968 8.78033 6.78033C8.63968 6.92098 8.44891 7 8.25 7H3.75C3.55109 7 3.36032 6.92098 3.21967 6.78033C3.07902 6.63968 3 6.44891 3 6.25V5.5C3 5.36739 2.94732 5.24021 2.85355 5.14645C2.75979 5.05268 2.63261 5 2.5 5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.5 8.5C2.77614 8.5 3 8.72386 3 9V10C3 10.2761 2.77614 10.5 2.5 10.5C2.22386 10.5 2 10.2761 2 10V9C2 8.72386 2.22386 8.5 2.5 8.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 8.5C9.77614 8.5 10 8.72386 10 9V10C10 10.2761 9.77614 10.5 9.5 10.5C9.22386 10.5 9 10.2761 9 10V9C9 8.72386 9.22386 8.5 9.5 8.5Z"
                fill="currentColor"
            />
        </svg>
    );
}
